<template>
    <div v-if="!loadingPage" class="pb-2">
        <b-alert variant="info" show>
            <p class="alert-body text-center">
                به جز نام، نام خانوادگی و شماره همراه بقیه اطلاعات در صورتی نمایش داده می‌شود که یک مجموعه
                مشخص شود.
            </p>
        </b-alert>
        <b-row class="mt-2">
            <b-col md="3" class="mt-25">
                <b-form-group label="مجموعه" label-for="storeId">
                    <v-select v-model="parameters.storeId" dir="rtl" :options="listStores" :reduce="(value) => value.id"
                        class="bg-white" autocomplete="off"
                        :get-option-label="(option) => option.name_Fa ? option.name_En + ' - ' + option.name_Fa : option.name_En"
                        :clearable="false">
                        <template #option="{ name_En, name_Fa }">
                            {{ name_En }} <span v-if="name_Fa">- {{ name_Fa }}</span>
                        </template>
                        <template #no-options>
                            موردی وجود ندارد
                        </template>
                    </v-select>
                </b-form-group>
            </b-col>
            <b-col md="3" class="mt-25">
                <b-form-group label="نام - نام خانوادگی - شماره اشتراک" label-for="searchTermId">
                    <b-form-input @keyup.enter="getCustomers" v-model="parameters.searchTerm" id="searchTermId"
                        autocomplete="off" class="text-center" name="searchTermId" />
                </b-form-group>
            </b-col>
            <b-col md="3" class="mt-25">
                <b-form-group label="شماره همراه" label-for="phoneNumberId">
                    <b-form-input dir="ltr" type="number" @keyup.enter="getCustomers" v-model="parameters.phoneNumber"
                        id="phoneNumberId" autocomplete="off" class="text-center" name="phoneNumberId" />
                </b-form-group>
            </b-col>
            <b-col md="3" class="mt-25">
                <b-form-group label="شماره سطح" label-for="levelNumberId">
                    <b-form-input dir="ltr" type="number" v-model="parameters.levelNumber" id="levelNumberId"
                        @keyup.enter="getCustomers" autocomplete="off" class="text-center" name="levelNumberId" />
                </b-form-group>
            </b-col>
            <b-col md="2" class="mt-25">
                <b-form-group label="از امتیاز" label-for="startScoreId">
                    <b-form-input dir="ltr" type="number" v-model="parameters.minScore" id="startScoreId"
                        @keyup.enter="getCustomers" autocomplete="off" class="text-center" name="startScoreId" />
                </b-form-group>
            </b-col>
            <b-col md="2" class="mt-25">
                <b-form-group label="تا امتیاز" label-for="endScoreId">
                    <b-form-input dir="ltr" type="number" v-model="parameters.maxScore" id="endScoreId"
                        @keyup.enter="getCustomers" autocomplete="off" class="text-center" name="endScoreId" />
                </b-form-group>
            </b-col>
            <b-col md="2" class="mt-25">
                <b-form-group label="از تعداد خرید" label-for="minTotalOrdersCountId">
                    <b-form-input dir="ltr" type="number" v-model="parameters.minTotalOrdersCount"
                        @keyup.enter="getCustomers" id="minTotalOrdersCountId" autocomplete="off" class="text-center"
                        name="minTotalOrdersCountId" />
                </b-form-group>
            </b-col>
            <b-col md="2" class="mt-25">
                <b-form-group label="تا تعداد خرید" label-for="maxTotalOrdersCountId">
                    <b-form-input dir="ltr" type="number" v-model="parameters.maxTotalOrdersCount"
                        @keyup.enter="getCustomers" id="maxTotalOrdersCountId" autocomplete="off" class="text-center"
                        name="maxTotalOrdersCountId" />
                </b-form-group>
            </b-col>
            <b-col md="2" class="mt-25">
                <b-form-group label="از زمان آخرین خرید" label-for="minDaysNumberSinceLastOrderedId">
                    <b-form-input dir="ltr" type="number" v-model="parameters.minDaysNumberSinceLastOrdered"
                        @keyup.enter="getCustomers" id="minDaysNumberSinceLastOrderedId" autocomplete="off"
                        class="text-center" name="minDaysNumberSinceLastOrderedId" />
                </b-form-group>
            </b-col>
            <b-col md="2" class="mt-25">
                <b-form-group label="تا زمان آخرین خرید" label-for="maxDaysNumberSinceLastOrderedId">
                    <b-form-input dir="ltr" type="number" v-model="parameters.maxDaysNumberSinceLastOrdered"
                        @keyup.enter="getCustomers" id="maxDaysNumberSinceLastOrderedId" autocomplete="off"
                        class="text-center" name="maxDaysNumberSinceLastOrderedId" />
                </b-form-group>
            </b-col>
            <b-col md="2" class="mt-25">
                <b-form-group label="از مبلغ خرید" label-for="minTotalOrdersAmountId">
                    <b-form-input dir="ltr" type="number" v-model="parameters.minTotalOrdersAmount"
                        @keyup.enter="getCustomers" id="minTotalOrdersAmountId" autocomplete="off" class="text-center"
                        name="minTotalOrdersAmountId" />
                </b-form-group>
            </b-col>
            <b-col md="2" class="mt-25">
                <b-form-group label="تا مبلغ خرید" label-for="maxTotalOrdersAmountId">
                    <b-form-input dir="ltr" type="number" v-model="parameters.maxTotalOrdersAmount"
                        @keyup.enter="getCustomers" id="maxTotalOrdersAmountId" autocomplete="off" class="text-center"
                        name="maxTotalOrdersAmountId" />
                </b-form-group>
            </b-col>
            <b-col md="3" class="mt-25">
                <b-form-group label="وفاداری" label-for="groupId">
                    <v-select v-model="parameters.groupId" :searchable="false" dir="rtl" :options="groupIdData"
                        :reduce="(value) => value.id" label="name" id="groupId" class="bg-white"
                        style="border-radius: 8px;" :clearable="false">
                        <template #no-options>
                            موردی وجود ندارد
                        </template>
                    </v-select>
                </b-form-group>
            </b-col>
            <b-col md="3" class="mt-25">
                <b-form-group label="نوع ترتیب نمایش" label-for="sortById">
                    <v-select v-model="parameters.sortBy" :searchable="false" dir="rtl" :options="sortByData"
                        :reduce="(value) => value.id" label="name" id="sortById" class="bg-white"
                        style="border-radius: 8px;" :clearable="false">
                        <template #no-options>
                            موردی وجود ندارد
                        </template>
                    </v-select>
                </b-form-group>
            </b-col>
            <b-col md="2" class="mt-25">
                <b-form-group label="ترتیب نمایش" label-for="sortDescendingId">
                    <v-select v-model="parameters.sortDescending" :searchable="false" dir="rtl" id="sortDescendingId"
                        :options="sortDescendingData" :reduce="(value) => value.id" label="name" class="bg-white"
                        style="border-radius: 8px;" :clearable="false">
                        <template #no-options>
                            موردی وجود ندارد
                        </template>
                    </v-select>
                </b-form-group>
            </b-col>
            <b-col md="2">
                <b-button @click="removeFilters" variant="info" class="mt-md-1 mt-50 w-100">حذف فیلتر ها</b-button>
            </b-col>
            <b-col md="2">
                <b-button @click="getCustomers" variant="primary" class="mt-2 mt-md-1 w-100">اعمال فیلتر</b-button>
            </b-col>
            <b-col md="2">
                <b-button @click="customersExport" variant="secondary" class="mt-2 mt-md-1 w-100">دانلود</b-button>
            </b-col>
            <b-col md="6" class="mt-2 mt-md-75">
                <div class="d-flex align-items-center justify-content-between border border-info rounded px-1"
                    style="height: 41px;">
                    <div class="d-flex align-items-center">
                        <feather-icon size="18" icon="UsersIcon" class="mr-50" />
                        <h5 class="mb-0">مشتریان یافت‌شده</h5>
                    </div>
                    <div class="d-flex align-items-center">
                        <div class="d-flex align-items-center mb-0 mr-50">
                            <h3 v-if="!loading" class="font-weight-bolder mb-0">{{ parameters.totalCount }}</h3>
                            <b-spinner v-else small></b-spinner>
                        </div>
                        <span>مشتری</span>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-card class="p-0 mt-2" no-body>
            <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                <b-table v-if="customerList.length" responsive :items="customerList" :fields="fields" class="mb-0"
                    striped>
                    <template #cell(ordersList)="data">
                        <router-link :to="`/customers/orders-list?id=${data.item.id}`">
                            <feather-icon icon="ArrowLeftIcon" size="19" />
                        </router-link>
                    </template>
                    <template #cell(walletBalance)="data">
                        {{ data.item.walletBalance.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(groupId)="data">
                        <div :style="{ color: customer_group_color(data.item.groupId) }">
                            {{ customer_group_name(data.item.groupId) }}
                        </div>
                    </template>
                    <template #cell(averageOrderIntervalDays)="data">
                        {{ data.item.averageOrderIntervalDays ? data.item.averageOrderIntervalDays : '-' }}
                    </template>
                    <template #cell(daysNumberSinceLastOrdered)="data">
                        {{ data.item.daysNumberSinceLastOrdered ? data.item.daysNumberSinceLastOrdered : '-' }}
                    </template>
                    <template #cell(lastName)="data">
                        {{ data.item.lastName ? data.item.lastName : '-' }}
                    </template>
                    <template #cell(firstName)="data">
                        {{ data.item.firstName ? data.item.firstName : '-' }}
                    </template>
                    <template #cell(loyaltyLevel)="data">
                        {{ data.item.loyaltyLevel ? data.item.loyaltyLevel.number : '-' }}
                    </template>
                    <template #cell(number)="data">
                        {{ data.item.number ? data.item.number : '-' }}
                    </template>
                    <template #cell(totalOrdersAmount)="data">
                        {{ data.item.totalOrdersAmount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(totalOrdersCount)="data">
                        {{ data.item.totalOrdersCount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(score)="data">
                        {{ data.item.score.toLocaleString('fa-IR') }}
                    </template>
                </b-table>
                <div v-else class="text-center pt-5 pb-4">
                    موردی وجود ندارد
                </div>
            </b-overlay>
        </b-card>
        <b-pagination align="center" @input="getCustomers" v-model="parameters.pageIndex"
            :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BForm, BFormRadio, BTable, BPagination, BOverlay, BAvatar, BFormInput, BFormGroup, BAlert, BSpinner } from 'bootstrap-vue';
import { adminService } from '@core/services';
import vSelect from 'vue-select';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BFormInput,
        BFormGroup,
        BForm,
        BFormRadio,
        BAlert,
        BSpinner,
        vSelect
    },
    data() {
        return {
            loadingPage: true,
            loading: false,
            customerList: [],
            fields: [
                {
                    key: 'firstName',
                    label: 'نام',
                },
                {
                    key: 'lastName',
                    label: 'نام خانوادگی',
                },
                {
                    key: 'phoneNumber',
                    label: 'شماره همراه',
                },
                {
                    key: 'number',
                    label: 'شماره اشتراک',
                },
                {
                    key: 'score',
                    label: 'امتیاز',
                },
                {
                    key: 'walletBalance',
                    label: 'موجودی کیف پول (ریال)',
                },
                {
                    key: 'totalOrdersAmount',
                    label: 'مبلغ خرید (ریال)',
                },
                {
                    key: 'totalOrdersCount',
                    label: 'تعداد خرید',
                },
                {
                    key: 'groupId',
                    label: 'وفاداری',
                },
                {
                    key: 'loyaltyLevel',
                    label: 'سطح',
                },
                {
                    key: 'averageOrderIntervalDays',
                    label: 'میانگین فاصله خرید (روز)',
                },
                {
                    key: 'daysNumberSinceLastOrdered',
                    label: 'آخرین خرید (روز)',
                },
                {
                    key: 'ordersList',
                    label: 'لیست سفارشات',
                },

            ],
            groupIdData: [
                { name: 'همراهِ همیشگی', id: 1 },
                { name: 'همراهِ هفتگی', id: 2 },
                { name: 'همراهِ ماهانه', id: 3 },
                { name: 'لبه‌ی فراموشی', id: 4 },
                { name: 'مشتریان خاموش', id: 5 },
            ],
            sortByData: [
                { name: 'تاریخ ایجاد', id: 0 },
                { name: 'امتیاز', id: 1 },
                { name: 'موجودی کیف پول', id: 2 },
                { name: 'زمان آخرین خرید', id: 3 },
                { name: 'تعداد خرید', id: 4 },
                { name: 'مبلغ خرید', id: 5 },
            ],
            sortDescendingData: [
                { name: 'صعودی', id: false },
                { name: 'نزولی', id: true }
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                phoneNumber: null,
                storeId: null,
                searchTerm: null,
                sortBy: null,
                levelNumber: null,
                sortDescending: null,
                maxScore: null,
                minScore: null,
                groupId: null,
                maxTotalOrdersCount: null,
                minTotalOrdersCount: null,
                maxTotalOrdersAmount: null,
                minTotalOrdersAmount: null,
                maxDaysNumberSinceLastOrdered: null,
                minDaysNumberSinceLastOrdered: null,
            },
            parametersStores: {
                pageIndex: 1,
                pageSize: 90,
            },
            listStores: [],
            BASE_URL: process.env.VUE_APP_BASE_URL,
        }
    },
    computed: {
        customer_group_name() {
            return (groupId) => {
                if (groupId == null) {
                    return '-'
                }
                if (groupId == 1) {
                    return 'همراهِ همیشگی'
                }
                if (groupId == 2) {
                    return 'همراهِ هفتگی'
                }
                if (groupId == 3) {
                    return 'همراهِ ماهانه'
                }
                if (groupId == 4) {
                    return 'لبه‌ی فراموشی'
                }
                if (groupId == 5) {
                    return 'مشتریان خاموش'
                }
            }
        },
        customer_group_color() {
            return (groupId) => {
                if (groupId == null) {
                    return null
                }
                if (groupId == 1) {
                    return '#50E3C2'
                }
                if (groupId == 2) {
                    return '#ffd057'
                }
                if (groupId == 3) {
                    return '#ffb446'
                }
                if (groupId == 4) {
                    return '#4A90E2'
                }
                if (groupId == 5) {
                    return '#847ad9'
                }
            }
        },
    },
    methods: {
        removeFilters() {
            this.parameters.phoneNumber = null;
            this.parameters.searchTerm = null;
            this.parameters.sortBy = null;
            this.parameters.levelNumber = null;
            this.parameters.sortDescending = null;
            this.parameters.maxScore = null;
            this.parameters.minScore = null;
            this.parameters.storeId = null;
            this.parameters.groupId = null;
            this.parameters.maxTotalOrdersCount = null;
            this.parameters.minTotalOrdersCount = null;
            this.parameters.maxTotalOrdersAmount = null;
            this.parameters.minTotalOrdersAmount = null;
            this.parameters.maxDaysNumberSinceLastOrdered = null;
            this.parameters.minDaysNumberSinceLastOrdered = null;
        },
        getCustomers() {
            this.loading = true
            adminService.getCustomers(this.parameters).then(({ data }) => {
                this.parameters.totalCount = data.totalCount
                this.customerList = data.items
                this.loading = false
                this.loadingPage = false
            })
        },
        customersExport() {
            this.loading = true
            const filteredParams = Object.fromEntries(
                Object.entries(this.parameters)
                    .filter(([key, value]) => value !== null)
            );
            const queryString = new URLSearchParams(filteredParams).toString();
            const url = `${this.BASE_URL}/admin/customers/export?${queryString}`;
            const accessToken = localStorage.getItem("accessToken");

            fetch(url, {
                method: 'GET',
                headers: new Headers({
                    "Authorization": "Bearer " + accessToken
                })
            })
                .then(response => response.blob())
                .then(blob => {
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = "customers.xlsx";
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    this.loading = false
                });
        },
        getListStores() {
            adminService.getListStores(this.parametersStores).then(({ data }) => {
                if (data.items.length) {
                    data.items.forEach(obj => {
                        if (obj.name_En) {
                            this.listStores.push(obj)
                        }
                    });
                }
                this.getCustomers()
            })
        },
    },
    mounted() {
        this.getListStores()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>